import Vue from 'vue'
import VueRouter from 'vue-router'
import Index from './views/Index.vue'
import store from './store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Index',
    component: Index,
    meta: {
      needsAuth: true,
      needsAdmin: false
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import(/* webpackChunkName: "login" */ './modules/auth/views/Login.vue'),
    meta: {
      layout: 'Login',
      guest: true,
      needsAuth: false,
      needsAdmin: false
    }
  },
  {
    path: '/password-reset',
    name: 'PasswordReset',
    component: () =>
      import(/* webpackChunkName: "password-reset" */ './modules/auth/views/PasswordReset.vue'),
    meta: {
      layout: 'Login',
      guest: true,
      needsAuth: false,
      needsAdmin: false
    }
  },
  {
    path: '/fahrzeuge',
    name: 'VehicleIndex',
    meta: {
      needsAuth: true,
      needsAdmin: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "vehicle.index" */ './views/vehicle/Index.vue')
  },
  {
    path: '/fahrzeuge/:id',
    name: 'vehicle-details',
    meta: {
      needsAuth: true,
      needsAdmin: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "vehicle.details" */ './views/vehicle/Details.vue')
  },
  {
    path: '/warenkorb',
    name: 'cart',
    meta: {
      needsAuth: true,
      needsAdmin: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "cart.index" */ './views/cart/Index.vue')
  },
  {
    path: '/bestellungen',
    name: 'orders',
    meta: {
      needsAuth: true,
      needsAdmin: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "order.index" */ './views/order/Index.vue')
  },
  {
    path: '/angebote',
    name: 'offers',
    meta: {
      needsAuth: true,
      needsAdmin: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "offer.index" */ './views/offer/Index.vue')
  },
  {
    path: '/faq',
    name: 'faq',
    meta: {
      needsAuth: true,
      needsAdmin: false
    },
    component: () => import(/* webpackChunkName: "faq.index" */ './views/faq/Index.vue')
  },
  {
    path: '/konto',
    name: 'account',
    meta: {
      needsAuth: true,
      needsAdmin: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "account.index" */ './views/account/Index.vue')
  },
  {
    path: '/preisaufschlaege',
    name: 'surcharge',
    meta: {
      needsAuth: true,
      needsAdmin: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "surcharge.index" */ './views/surcharge/Index.vue')
  },
  {
    path: '/ansicht-einstellungen',
    name: 'view-settings',
    meta: {
      needsAuth: true,
      needsAdmin: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "settings.index" */ './views/settings/Index.vue')
  },
  {
    path: '/fahrzeugpakete',
    name: 'VehiclePackages',
    meta: {
      needsAuth: true,
      needsAdmin: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "vehicle.index" */ './views/packages/Index.vue')
  },
  {
    path: '/exchange',
    name: 'exchange.index',
    meta: {
      needsAuth: true,
      needsAdmin: false
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "exchange.index" */ './views/exchange/Index.vue')
  },
  {
    path: '/admin',
    name: 'admin.dashboard',
    meta: {
      needsAuth: true,
      needsAdmin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin.dashboard" */ './views/admin/Dashboard.vue')
  },
  {
    path: '/admin/haendler',
    name: 'admin.merchant',
    meta: {
      needsAuth: true,
      needsAdmin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin.merchant" */ './views/admin/Merchants.vue')
  },
  {
    path: '/admin/haendler/anlegen',
    name: 'admin.merchant.create',
    meta: {
      needsAuth: true,
      needsAdmin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "admin.merchant.create" */ './views/admin/MerchantCreate.vue')
  },
  {
    path: '/admin/haendler/:id',
    name: 'admin.merchant.details',
    meta: {
      needsAuth: true,
      needsAdmin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "admin.merchant.details" */ './views/admin/MerchantDetails.vue')
  },
  {
    path: '/admin/bestellungen',
    name: 'admin.orders',
    meta: {
      needsAuth: true,
      needsAdmin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin.orders" */ './views/admin/Orders.vue')
  },
  {
    path: '/admin/bestellungen/:id',
    name: 'admin.order.details',
    meta: {
      needsAuth: true,
      needsAdmin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () =>
      import(/* webpackChunkName: "admin.order.details" */ './views/admin/OrderDetails.vue')
  },
  {
    path: '/admin/angebote',
    name: 'admin.offers',
    meta: {
      needsAuth: true,
      needsAdmin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin.offers" */ './views/admin/Offers.vue')
  },
  {
    path: '/admin/banner',
    name: 'admin.banner',
    meta: {
      needsAuth: true,
      needsAdmin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin.banner" */ './views/admin/Banner.vue')
  },
  {
    path: '/admin/exchange',
    name: 'admin.exchange.index',
    meta: {
      needsAuth: true,
      needsAdmin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin.exchange.index" */ './views/admin/exchange/Index.vue')
  },
  {
    path: '/admin/exchange/vehicle/edit/:id?',
    name: 'admin.exchange.vehicle.edit',
    meta: {
      needsAuth: true,
      needsAdmin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin.exchange.vehicle.edit" */ './views/admin/exchange/vehicle/Edit.vue')
  },
  {
    path: '/admin/einstellungen',
    name: 'admin.settings',
    meta: {
      needsAuth: true,
      needsAdmin: true
    },
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import(/* webpackChunkName: "admin.settings" */ './views/admin/Settings.vue')
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  /*
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  */
  routes
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.needsAdmin) && !store.state.auth.user.isAdmin) {
    next({ name: 'Index' })
  } else {
    next()
  }
  if (to.matched.some(record => record.meta.needsAuth)) { 
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    store
      .dispatch('auth/checkTokenExists')
      .then(() => {
        next()
      })
      .catch(() => {
        next({
          path: '/login',
          query: { redirect: to.fullPath }
        })
      })
  } else {
    next()
  }

  if(to.name === 'faq' && store.state.tenant.knumber !== 'K10122' && store.state.tenant.knumber !== 'K10151') {
    next({ name: 'Index' })
  }else {
    next()
  }
})

export default router
